import { useState } from "react";

/** Dry-run view of the exact request that Generate will send, plus copy / copy-as-cURL. */
export function PayloadPreview({
  payload,
  curl,
  imageUrl,
  note,
}: {
  payload: object | null;
  curl: string | null;
  imageUrl: string;
  note?: string | undefined;
}) {
  const [copied, setCopied] = useState<string | null>(null);
  const copy = (what: string, text: string): void => {
    void navigator.clipboard.writeText(text);
    setCopied(what);
    setTimeout(() => setCopied(null), 1200);
  };

  if (!payload) return <p className="lab-empty">Pick a target metal or a loose stone to form a request.</p>;
  const json = JSON.stringify(payload, null, 2);
  return (
    <div className="lab-payload">
      <div className="route">
        POST <b>{"{gateway}"}</b>/ring-swap/v1/generations
      </div>
      <pre className="json">{json}</pre>
      <div className="mono small muted lab-src">source → {imageUrl || "—"}</div>
      {note && <div className="warn small">⚠ {note}</div>}
      <div className="lab-copyrow">
        <button className="btn small-btn" onClick={() => copy("payload", json)}>
          {copied === "payload" ? "Copied!" : "Copy payload"}
        </button>
        {curl && (
          <button className="btn small-btn" onClick={() => copy("curl", curl)}>
            {copied === "curl" ? "Copied!" : "Copy as cURL"}
          </button>
        )}
      </div>
    </div>
  );
}
